<template>
  <header class="main-header">
    <!-- Logo -->
    <router-link to="/">
      <a href="" class="logo">
        <!-- mini logo for sidebar mini 50x50 pixels -->
        <span class="logo-mini"><b>C</b>RM</span>
        <!-- logo for regular state and mobile devices -->
        <span class="logo-lg"><b>Admin</b> CRM</span>
      </a>
    </router-link>
    <!-- Header Navbar: style can be found in header.less -->
    <nav class="navbar navbar-static-top">
      <!-- Sidebar toggle button-->
      <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
        <span class="sr-only">Toggle navigation</span>
      </a>
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu">
        <ul class="nav navbar-nav">
          <!-- Messages: style can be found in dropdown.less-->
          <!--          <li class="dropdown messages-menu">-->
          <!--            <a href="#" class="dropdown-toggle" data-toggle="dropdown">-->
          <!--              <i class="fa fa-envelope-o"></i>-->
          <!--              <span class="label label-success">{{ unreadMessagesCount }}</span>-->
          <!--            </a>-->
          <!--            <ul class="dropdown-menu">-->
          <!--              <li class="header">You have {{ unreadMessagesCount }} messages</li>-->
          <!--              <li>-->
          <!--                &lt;!&ndash; inner menu: contains the actual data &ndash;&gt;-->
          <!--                <ul class="menu">-->
          <!--                  <li>&lt;!&ndash; start message &ndash;&gt;-->
          <!--                    <a href="#">-->
          <!--                      <div class="pull-left">-->
          <!--                        <img src="~admin-lte/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image">-->
          <!--                      </div>-->
          <!--                      <h4>-->
          <!--                        Support Team-->
          <!--                        <small><i class="fa fa-clock-o"></i> 5 mins</small>-->
          <!--                      </h4>-->
          <!--                      <p>Why not buy a new awesome theme?</p>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  &lt;!&ndash; end message &ndash;&gt;-->
          <!--                  <li>-->
          <!--                    <a href="#">-->
          <!--                      <div class="pull-left">-->
          <!--                        <img src="~admin-lte/dist/img/user3-128x128.jpg" class="img-circle" alt="User Image">-->
          <!--                      </div>-->
          <!--                      <h4>-->
          <!--                        AdminLTE Design Team-->
          <!--                        <small><i class="fa fa-clock-o"></i> 2 hours</small>-->
          <!--                      </h4>-->
          <!--                      <p>Why not buy a new awesome theme?</p>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <a href="#">-->
          <!--                      <div class="pull-left">-->
          <!--                        <img src="~admin-lte/dist/img/user4-128x128.jpg" class="img-circle" alt="User Image">-->
          <!--                      </div>-->
          <!--                      <h4>-->
          <!--                        Developers-->
          <!--                        <small><i class="fa fa-clock-o"></i> Today</small>-->
          <!--                      </h4>-->
          <!--                      <p>Why not buy a new awesome theme?</p>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <a href="#">-->
          <!--                      <div class="pull-left">-->
          <!--                        <img src="~admin-lte/dist/img/user3-128x128.jpg" class="img-circle" alt="User Image">-->
          <!--                      </div>-->
          <!--                      <h4>-->
          <!--                        Sales Department-->
          <!--                        <small><i class="fa fa-clock-o"></i> Yesterday</small>-->
          <!--                      </h4>-->
          <!--                      <p>Why not buy a new awesome theme?</p>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  <li>-->
          <!--                    <a href="#">-->
          <!--                      <div class="pull-left">-->
          <!--                        <img src="~admin-lte/dist/img/user4-128x128.jpg" class="img-circle" alt="User Image">-->
          <!--                      </div>-->
          <!--                      <h4>-->
          <!--                        Reviewers-->
          <!--                        <small><i class="fa fa-clock-o"></i> 2 days</small>-->
          <!--                      </h4>-->
          <!--                      <p>Why not buy a new awesome theme?</p>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                </ul>-->
          <!--              </li>-->
          <!--              <li class="footer"><a href="#">See All Messages</a></li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!-- Notifications: style can be found in dropdown.less -->
          <li class="dropdown notifications-menu">
            <a class="dropdown-toggle" data-toggle="dropdown" href="#">
              <i class="fa fa-bell-o"></i>
              <span v-show="unreadNotificationsCount > 0" class="label label-warning">{{
                  unreadNotificationsCount
                }}</span>
            </a>
            <ul class="dropdown-menu" style="min-width: fit-content">
              <!--              <li class="header">You have {{ newNoti }} new notifications</li>-->
              <li>
                <!-- inner menu: contains the actual data -->
                <ul id="infinite-list" class="menu">
                  <li v-if="hasNoti"
                      class="d-flex justify-content-center my-2"
                      style="cursor:pointer"
                      @click="markAllAsRead"
                  >
                    <b-button variant="success">Đánh dấu tất cả đã đọc</b-button>
                  </li>
                  <li v-for="notification in notifications" :key="notification.id"
                      :style="notification.unread ? 'background-color:#cefad0' : ''" style="cursor:pointer">
                    <a @click.prevent="() => updateUnreadNoti(notification.id)">
                      {{ parseContent(notification.content, notification.type).customerInfoText }}
                      <span :class="parseContent(notification.content, notification.type).style">
                         {{ parseContent(notification.content, notification.type).text }}
                       </span>
                      <span class="font-italic"> ({{
                          parseTime(notification.created_at)
                        }}) </span>
                    </a>
                  </li>
                  <li v-if="!hasNoti" class="d-flex justify-content-center">
                    <div class="my-2" style="white-space: nowrap"> Không có thông báo nào</div>
                  </li>
                </ul>
              </li>
<!--              <li class="footer"><a href="#">View all</a></li>-->
            </ul>
          </li>
          <!-- Tasks: style can be found in dropdown.less -->
          <!--          <li class="dropdown tasks-menu">-->
          <!--            <a href="#" class="dropdown-toggle" data-toggle="dropdown">-->
          <!--              <i class="fa fa-flag-o"></i>-->
          <!--              <span class="label label-danger">{{ remainTasksCount }}</span>-->
          <!--            </a>-->
          <!--            <ul class="dropdown-menu">-->
          <!--              <li class="header">You have {{ remainTasksCount }} tasks</li>-->
          <!--              <li>-->
          <!--                &lt;!&ndash; inner menu: contains the actual data &ndash;&gt;-->
          <!--                <ul class="menu">-->
          <!--                  <li>&lt;!&ndash; Task item &ndash;&gt;-->
          <!--                    <a href="#">-->
          <!--                      <h3>-->
          <!--                        Design some buttons-->
          <!--                        <small class="pull-right">20%</small>-->
          <!--                      </h3>-->
          <!--                      <div class="progress xs">-->
          <!--                        <div class="progress-bar progress-bar-aqua" style="width: 20%" role="progressbar"-->
          <!--                             aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">-->
          <!--                          <span class="sr-only">20% Complete</span>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  &lt;!&ndash; end task item &ndash;&gt;-->
          <!--                  <li>&lt;!&ndash; Task item &ndash;&gt;-->
          <!--                    <a href="#">-->
          <!--                      <h3>-->
          <!--                        Create a nice theme-->
          <!--                        <small class="pull-right">40%</small>-->
          <!--                      </h3>-->
          <!--                      <div class="progress xs">-->
          <!--                        <div class="progress-bar progress-bar-green" style="width: 40%" role="progressbar"-->
          <!--                             aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">-->
          <!--                          <span class="sr-only">40% Complete</span>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  &lt;!&ndash; end task item &ndash;&gt;-->
          <!--                  <li>&lt;!&ndash; Task item &ndash;&gt;-->
          <!--                    <a href="#">-->
          <!--                      <h3>-->
          <!--                        Some task I need to do-->
          <!--                        <small class="pull-right">60%</small>-->
          <!--                      </h3>-->
          <!--                      <div class="progress xs">-->
          <!--                        <div class="progress-bar progress-bar-red" style="width: 60%" role="progressbar"-->
          <!--                             aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">-->
          <!--                          <span class="sr-only">60% Complete</span>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  &lt;!&ndash; end task item &ndash;&gt;-->
          <!--                  <li>&lt;!&ndash; Task item &ndash;&gt;-->
          <!--                    <a href="#">-->
          <!--                      <h3>-->
          <!--                        Make beautiful transitions-->
          <!--                        <small class="pull-right">80%</small>-->
          <!--                      </h3>-->
          <!--                      <div class="progress xs">-->
          <!--                        <div class="progress-bar progress-bar-yellow" style="width: 80%" role="progressbar"-->
          <!--                             aria-valuenow="20" aria-valuemin="0" aria-valuemax="100">-->
          <!--                          <span class="sr-only">80% Complete</span>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </a>-->
          <!--                  </li>-->
          <!--                  &lt;!&ndash; end task item &ndash;&gt;-->
          <!--                </ul>-->
          <!--              </li>-->
          <!--              <li class="footer">-->
          <!--                <a href="#">View all tasks</a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </li>-->
          <!-- User Account: style can be found in dropdown.less -->
          <li class="dropdown user user-menu">
            <a href="#" class="dropdown-toggle" data-toggle="dropdown">
              <img src="~admin-lte/dist/img/user2-160x160.jpg" class="user-image" alt="User Image">
              <span class="hidden-xs">{{ currentUser.user_info.username }}</span>
            </a>
            <ul class="dropdown-menu">
              <!-- User image -->
              <li class="user-header">
                <img src="~admin-lte/dist/img/user2-160x160.jpg" class="img-circle" alt="User Image">
                <p>{{ currentUser.user_info.username }} - {{ roles[0] }}
                <small>{{ company }}</small>
                </p>
<!--                <span v-for="role in roles" :key="role">{{ role }}</span>-->
              </li>
              <!-- Menu Footer-->
              <li class="user-footer">
                <div class="pull-left">
                  <a href="#" class="btn btn-default btn-flat">Hồ sơ</a>
                </div>
                <div class="pull-right">
                  <a @click.prevent="logoutAction" class="btn btn-default btn-flat">Đăng xuất</a>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <b-modal size='xl' id="phone-call-modal" @hide="() => this.closePopup()" hide-footer>
        <template #modal-header="{ close }" >
          <div class="d-flex justify-content-between w-100">
            <i class="fa fa-cog" id="deviceSetting" />
            <i class="fa fa-times" @click="close()" />
          </div>
        </template>
        <b-popover target="deviceSetting" triggers="hover focus" placement="bottomleft">
          <p>
            <i class="fa fa-microphone" />
            Đầu vào âm thanh
          </p>
          <b-form-select :options="inputDevices" v-model="audioInput" @change="changeAudioInput">
          </b-form-select>
          <p class="mt-3">
            <i class="fa fa-volume-up" />
            Đầu ra âm thanh
          </p>
          <b-form-select :options="outputDevices" v-model="audioOutput" @change="changeAudioOutput">
          </b-form-select>
        </b-popover>
        <SoftPhone :audioInput="audioInput" :audioOutput="audioOutput"></SoftPhone>
      </b-modal>
      <div v-if="showCallIcon" class="telephone-icon">
        <span v-if="connectionState === 'Started'" class="connected"></span>
        <span v-else class="disconnected"></span>
        <button class="call-btn" v-if="trialWarning || trialExpired" @click="showPhoneWarning" :style="{'background': trialExpired ? 'red': '#f5c33b'}">
          <img src="../assets/icon/telephone_warning_icon.svg" alt="logo" width="100%">
        </button>
        <button v-else class="call-btn" @click="showSoftphone">
          <i class="fa fa-phone" aria-hidden="true"></i>
        </button>
      </div>
    </nav>
  </header>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Utils from '../common/utils'
import SoftPhone from './telephone/SoftPhone'
import ity from '../lib/ity'
import {CALL_STATE, NOTIFICATION_TYPE} from '../common/constant'
import callCenterAPI from '../api/callCenter'
import notificationAPI from '../api/notification'
import Cookies from 'js-cookie'
import moment from 'moment'
import infiniteScroll from 'vue-infinite-scroll'
import {uniqBy} from 'lodash/array'
import {cloneDeep} from 'lodash'
import currencyInput from './CurrencyInput'

export default {
  name: 'va-navibar',
  directives: {
    infiniteScroll
  },
  components: {
    SoftPhone,
  },
  computed: {
    ...mapGetters([
      'notifications',
      'unreadMessagesCount',
      'unreadNotificationsCount',
      'remainTasksCount',
      'currentUser'
    ]),
    notiPage () {
      return Math.floor(this.notifications.length / 10)
    },
    hasNoti () {
      return this.notifications.length > 0
    },
    callState () {
      return ity.callState
    },
    connectionState () {
      return ity.ua ? ity.ua.userAgent._state : null
    },
    ua () {
      return ity.ua
    }
  },
  data () {
    return {
      roles: [],
      company: null,
      showCallIcon: false,
      inputDevices: [],
      outputDevices: [],
      audioInput: Cookies.get('audioInput') || null,
      audioOutput: Cookies.get('audioOutput') || null,
      interval: null,
      trialWarning: false,
      trialExpired: false,
      notificationsLoading: false,
      newNoti: 0,
      from_time: null,
    }
  },
  mounted () {
    this.getRoles()
    this.showCallIcon = this.currentUser.user_info.call_center.sip_server !== null
    this.getTrialWarning()
    navigator.mediaDevices.getUserMedia({audio: true, video: false})
      .then(stream => {
        navigator.mediaDevices.enumerateDevices().then(devices => {
          devices.forEach(d => {
            if (d.kind === 'audioinput') {
              this.inputDevices.push({value: d.deviceId, text: d.label})
              this.audioInput = d.deviceId
              this.changeAudioInput(d.deviceId)
            }
            if (d.kind === 'audiooutput') {
              if (this.audioOutput === null) {
                this.audioOutput = d.deviceId
                this.changeAudioOutput(d.deviceId)
              }
              this.outputDevices.push({value: d.deviceId, text: d.label})
            }
          })
        })
      })
      .catch(error => {
        console.log('Error :', error)
        this.audioInput = null
        this.audioOutput = null
      })
    const listElm = document.querySelector('#infinite-list')
    listElm.addEventListener('scroll', e => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
        this.fetchNotification()
      }
    })

    this.fetchNotification().then(() => {
      this.newNoti = this.notifications.filter(n => n.unread).length
    }).finally(() => {
      // this.interval = setInterval(() => {
      //   this.fetchNotification(true)
      //   this.getTrialWarning()
      // }, 30000)
    })
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions([
      'logout',
      'changePhoneNumber',
      'openSoftphone',
      'updateNoti'
    ]),
    async fetchNotification (fetchNewUnread = false) {
      if (this.currentUser.user_info && !Utils.isSuperUser(this.currentUser.user_info)) {
        this.notificationsLoading = true
        const res = await notificationAPI.filter({
          page: fetchNewUnread ? 0 : this.notiPage,
          filter: {
            ...(Boolean(this.from_time) && fetchNewUnread) && {from_time: this.from_time, is_unread: true},
          }
        })
        if (res.status === 200) {
          const data = res.data.data.records || []
          const _notifications = fetchNewUnread ? [...data, ...this.notifications] : [...this.notifications, ...data]
          if (fetchNewUnread) {
            this.newNoti += data.filter(n => n.unread).length
          }
          this.from_time = moment().format('YYYY-MM-DD HH:mm:ss')
          this.updateNoti({status: uniqBy(_notifications, 'id')})
          this.notificationsLoading = false
        }
      }
    },
    getTrialWarning () {
      const {id: company_id} = Utils.getCompanyByUserInfo(this.currentUser.user_info)
      if (!company_id || !this.showCallIcon) return
      callCenterAPI.get_callcenter({company_id}).then(res => {
        if (res != null && res.data != null) {
          if (res.data.data.id) {
            this.trialWarning = res.data.data.trial_warning
            this.trialExpired = res.data.data.trial_expired
          }
        }
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
      })
    },
    showPhoneWarning () {
      const message = this.trialExpired ? 'Công ty đã dùng quá số tiền ứng trước cho chức năng tổng đài'
        : 'Công ty sắp dùng hết số tiền ứng trước cho chức năng tổng đài'
      this.$bvModal.msgBoxOk(message, {
        title: false,
        buttonSize: 'sm',
        centered: true,
        size: 'sm',
      }).then(res => {
        this.showSoftphone()
      })
    },
    parseContent (content, type) {
      if (!content) return null
      try {
        const _content = JSON.parse(content)
        const phone = _content.phone ? `${_content.phone} - ` : ''
        const name = _content.customer_name ? `${_content.customer_name} - ` : ''
        switch (type) {
          case NOTIFICATION_TYPE.APPROVE_PAYMENT:
            return {
              style: 'text-green',
              text: 'Đã duyệt',
              customerInfoText: phone + name
            }
          case NOTIFICATION_TYPE.UNAPPROVE_PAYMENT:
            return {
              style: 'text-red',
              text: 'Chưa duyệt',
              customerInfoText: phone + name
            }
          case NOTIFICATION_TYPE.DEBT:
            return {
              style: 'text-green',
              text: 'Còn thiếu nợ ' + _content.debt | currencyInput + ' vnđ',
              customerInfoText: phone + name
            }
          case NOTIFICATION_TYPE.RENEW:
            return {
              style: 'text-green',
              text: 'Cần gia hạn sử dụng',
              customerInfoText: phone + name
            }
          case NOTIFICATION_TYPE.ANNUAL_BUY:
            return {
              style: 'text-green',
              text: 'Vừa được thêm sản phẩm mới',
              customerInfoText: phone + name
            }
          case NOTIFICATION_TYPE.NEW_PAYMENT:
            return {
              style: 'text-green',
              text: 'Chờ thanh toán',
              customerInfoText: phone + name
            }
          default:
            return {
              style: '',
              text: ''
            }
        }
      } catch (e) {
        return null
      }
    },
    parseType (type) {
      switch (type.toLowerCase()) {
        case 'approve_payment':
          return {
            style: 'text-green',
            text: 'Đã duyệt'
          }
        case 'unapprove_payment':
          return {
            style: 'text-red',
            text: 'Chưa duyệt'
          }
        default:
          return {
            style: '',
            text: ''
          }
      }
    },
    parseTime (created_at) {
      if (!created_at) return null
      try {
        let diff = moment().diff(moment(created_at), 'day')
        if (diff) {
          return diff + 'ngày trước'
        } else {
          diff = moment().diff(moment(created_at), 'hour')
          if (diff) {
            return diff + 'giờ trước'
          } else {
            diff = moment().diff(moment(created_at), 'minute')
            return diff + 'phút trước'
          }
        }
      } catch (e) {
        return null
      }
    },
    async updateUnreadNoti (notiId) {
      try {
        if (notiId) {
          const idx = this.notifications.findIndex(n => n.id === notiId)
          if (idx > -1) {
            await notificationAPI.updateUnread({id: notiId, unread: !this.notifications[idx].unread})
            let _notifications = cloneDeep(this.notifications)
            _notifications[idx].unread = !this.notifications[idx].unread
            this.updateNoti({status: _notifications})
          }
        } else {
          // const notificationIds = this.notifications.filter(n => n.is_unread).map(n => n.id)
          // if (!notificationIds.length) return
          // await Promise.all(notificationIds.map(id => notificationAPI.updateUnread(id)))
        }
        const notiElm = document.querySelector('.notifications-menu')
        notiElm.classList.add('open')
      } catch (e) {
        console.log(e)
      }
    },
    async markAllAsRead () {
      try {
        await notificationAPI.markAllAsRead()
        let _notifications = this.notifications.map(n => ({
          ...n,
          unread: false
        }))
        this.updateNoti({status: _notifications})
      } catch (e) {
        alert(e)
      }
    },
    resetNewNoti () {
      this.newNoti = 0
    },
    logoutAction () {
      if (this.ua) {
        this.ua.disconnect()
      }
      this.logout()
    },
    getNotificationIcon (type) {
      return 'fa fa-users text-aqua'
    },
    getRoles () {
      if (this.currentUser.user_info.roles && this.currentUser.user_info.roles.length > 0) {
        this.roles = this.currentUser.user_info.roles.filter(item => item.role != null).map(item => item.role.role_name)
        this.company = this.currentUser.user_info.roles[0].company.name
      }

      if (Utils.isSuperUser(this.currentUser.user_info)) {
        this.roles.push('Super Admin')
      }

      if (Utils.isAdminUser(this.currentUser.user_info)) {
        this.roles.push('Admin')
        this.company = this.currentUser.user_info.roles[0].company.name
      }
    },
    showSoftphone () {
      this.changePhoneNumber({phoneNumber: ''})
      this.openSoftphone({status: true})
      this.$bvModal.show('phone-call-modal')
    },
    closePopup () {
      this.openSoftphone({status: false})
    },
    changeAudioInput (value) {
      Cookies.set('audioInput', value, {expires: 1})
      ity.ua.changeAudioInput(value)
    },
    changeAudioOutput (value) {
      let mediaElement = document.getElementById('remoteAudio')
      mediaElement.setSinkId(value)
      Cookies.set('audioOutput', value, {expires: 1})
    }
  },
  watch: {
    callState: {
      handler: function () {
        if (this.callState === CALL_STATE.RECEIVED) {
          this.$bvModal.show('phone-call-modal')
          callCenterAPI.start_callin().then(res => {}).catch(() => {})
        }
      }
    },
  },
}

</script>



// WEBPACK FOOTER //
// src/components/NaviBar.vue